




























import { Component, Mixins, Prop } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import OzContainedButton, {
  OzContainedButtonColorScheme,
  OzContainedButtonSizePreset,
} from 'library/v4/components/OzContainedButton.vue'

@Component({ components: { OzContainedButton } })
export default class SurfacePostModeration extends Mixins() {
  OzContainedButtonSizePreset = OzContainedButtonSizePreset
  OzContainedButtonColorScheme = OzContainedButtonColorScheme

  @Prop({ required: true }) colorScheme!: 'light' | 'dark'
  @Getter isStream!: boolean

  deletePost(): void {
    this.$emit('delete')
  }
  approve(): void {
    this.$emit('approve')
  }
}
